import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  listBuildEmployer,
  listHireEmployer,
} from "../../actions/employerAction";
import Message from "../../components/Message";
import RightDash from "../../components/RightDash";
import EmployerWelcome from "../../components/EmployerWelcome";
import EmployerMenu from "../../components/EmployerMenu";
import Signout from "../../components/Signout";
import Login from "../Login";
import "../../styles/dashboard.css";

const EmployerRequests = ({ history, resizeMenu, setResizeMenu }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const listBuild = useSelector((state) => state.listBuild);

  const { loading, jobs, error } = listBuild;

  const listHire = useSelector((state) => state.listHire);

  const { hireloading, hire } = listHire;

  useEffect(() => {
    dispatch(listBuildEmployer());
    dispatch(listHireEmployer());
  }, [listBuildEmployer, listHireEmployer]);

  // if (!userInfo) {
  //   return <Login />;
  // }

  // if (userInfo && userInfo.role === "developer") {
  //   history.push("/developer/dashboard");
  // }

  return (
    <div className="dashboard">
      <EmployerMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">
            {error} <a href="/employer/requests">refresh page</a>
          </Message>
        ) : (
          <div className="right-wrapper">
            <EmployerWelcome />
            <div className="main p-3">
              <h4 className="font-medium mb-2">Requests</h4>
              <div className="my-2 mx-25">
                <h4 className="font-normal mb-25">Jobs (recent)</h4>
                <div className="overflow-x">
                  <div>
                    {jobs && jobs.length === 0 && <div>No job posted yet</div>}
                    {jobs &&
                      jobs.slice(0, 5).map((job) => (
                        <div
                          key={job._id}
                          className="d-flex justify-content-between align-items-center table shadow-sm border mb-1 px-1 py-50">
                          <div>
                            <div>
                              <span className="date">
                                {job.createdAt.slice(0, 10)}
                              </span>
                            </div>
                            <div className="title">
                              <Link to={`/employer/job/${job._id}`}>
                                {" "}
                                {job.title}
                              </Link>
                            </div>
                            <div className="application font-weight-bolder">
                              Total Application -{" "}
                              <span className="font-weight-bolder">
                                {job.devapplied.length}
                              </span>
                            </div>
                          </div>
                          <div className="">
                            <div className="budget">Budget - ${job.budget}</div>
                            <div className="status d-flex align-items-center text-capitalise">
                              {" "}
                              <div
                                className={`status-bar mr-25 vertical-middle ${
                                  job.status === "negotiation"
                                    ? "bluebar"
                                    : job.status === "progress"
                                    ? "yellowbar"
                                    : "greenbar"
                                }`}></div>{" "}
                              {job.status}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="my-2 mt-3 mx-25">
                <h4 className="font-normal mb-25">Hire requests (recent)</h4>
                <div className="overflow-x">
                  <div>
                    {hire.length === 0 && <div>No hire request posted yet</div>}
                    {hire.slice(0, 5).map((hire) => (
                      <div
                        key={hire._id}
                        className="d-flex justify-content-between align-items-center table shadow-sm border mb-1 px-1 py-50">
                        <div>
                          <div className="date">
                            {hire.createdAt.slice(0, 10)}
                          </div>
                          <div className="nameemail">
                            by {hire.name} -{" "}
                            <a href={`mailto:${hire.email}`}>{hire.email}</a>
                          </div>
                          <div className="company">
                            {hire.company} - {hire.country}
                          </div>
                          <div className="requestmade font-weight-bolder">
                            Employee request -{" "}
                            <span className="font-weight-bolder">
                              {hire.employeesnumber}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div className="budget font-weight-bolder text-right">
                            skills
                          </div>
                          <div className="status text-right font-sm">
                            {hire.skillrequest.join(", ")}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default EmployerRequests;
